import styled from '@emotion/styled';
import {
  Button,
  Column,
  FormTitle,
  Row,
  useMedia,
  theme,
  typography,
} from '@landsbankinn/ui';
import * as React from 'react';
import { useEffect, useRef } from 'react';
import { DatepickerWithCheckmark } from '../../icons/DatepickerWithCheckmark';

const Text = styled.p`
  ${typography.body}
  margin-bottom: ${(props) => props.theme.baseline * 7}px;
`;

const StyledButton = styled(Button)`
  width: 100%;
`;
const SvgColumn = styled(Column)`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Icon = styled(DatepickerWithCheckmark)`
  width: 100%;
`;

interface IProps {
  setStep: React.Dispatch<React.SetStateAction<'form' | 'success'>>;
}

export function Success({ setStep }: IProps) {
  const isDesktop = useMedia('lg');
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (ref) {
      ref.current?.focus();
    }
  }, [ref]);

  return (
    <>
      <Row ref={ref}>
        <Column
          sm={{ width: 12 / 12 }}
          md={{ width: 10 / 12, offset: 1 / 12 }}
          lg={{ width: 5 / 12, offset: 1 / 12 }}
        >
          <FormTitle text="Pöntun gjafakorts móttekin" />

          <Row>
            <Column sm={{ width: 12 / 12 }} lg={{ width: 9.8 / 12 }}>
              <Text>
                Við munum hafa samband til að ganga frá kaupum og finna tíma sem
                hentar þér til afhendingar kortsins. Pantanir í desember geta
                tekið allt að þrjá virka daga í afgreiðslu.
              </Text>
              <StyledButton
                title="Panta annað gjafakort"
                bg={theme.colors.primary}
                onClick={() => setStep('form')}
              />
            </Column>
          </Row>
        </Column>
        {isDesktop && (
          <SvgColumn md={{ width: 5 / 12 }} lg={{ width: 6 / 12 }}>
            <Icon />
          </SvgColumn>
        )}
      </Row>
    </>
  );
}
